/*=========================================================================================
  File Name: getters.js
  Description: Vuex Store - getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// added so later we can keep breakpoint in sync automatically using this config file
// import tailwindConfig from "../../tailwind.config.js"


// COMPONENT
// vx-autosuggest
// starredPages: state => state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),
export function windowBreakPoint (state) {

  // This should be same as tailwind. So, it stays in sync with tailwind utility classes
  if (state.windowWidth >= 1200) return 'xl'
  else if (state.windowWidth >= 992) return 'lg'
  else if (state.windowWidth >= 768) return 'md'
  else if (state.windowWidth >= 576) return 'sm'
  else return 'xs'
}

export function scrollbarTag (state) {
  return state.is_touch_device ? 'div' : 'VuePerfectScrollbar'
}

export function navMenuItems (state) {
  return state.navMenuItems
}

export function getCurrentUserPhoto () {
  return require('@/assets/images/portrait/small/avatar-s-11.jpg')
}

export function appVersion (state) {
  return state.PACKAGE_VERSION
}
